var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79961 10.0001L9.39961 13.0001L14.1996 7.0001M9.99961 18.4001C8.89651 18.4001 7.8042 18.1828 6.78507 17.7607C5.76593 17.3385 4.83992 16.7198 4.05991 15.9398C3.2799 15.1598 2.66116 14.2338 2.23902 13.2146C1.81688 12.1955 1.59961 11.1032 1.59961 10.0001C1.59961 8.89699 1.81688 7.80469 2.23902 6.78556C2.66116 5.76642 3.2799 4.84041 4.05991 4.0604C4.83992 3.28039 5.76593 2.66165 6.78507 2.23951C7.8042 1.81737 8.89651 1.6001 9.99961 1.6001C12.2274 1.6001 14.364 2.4851 15.9393 4.0604C17.5146 5.63571 18.3996 7.77228 18.3996 10.0001C18.3996 12.2279 17.5146 14.3645 15.9393 15.9398C14.364 17.5151 12.2274 18.4001 9.99961 18.4001Z",
    stroke: "#009332",
    strokeWidth: 1.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.b4f26ca5b2b3ba20bc4acf1cc83d4aad.svg";
export { ForwardRef as ReactComponent };